.chip {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: none;
  inline-size: 1.75rem;
  block-size: 1.75rem;
  border-radius: var(--radius-sm);
  /* Not a token on purpose: the mark's brand colours were drawn for white, in either theme. */
  background: #ffffff;
}

.mark {
  inline-size: 1.125rem;
  block-size: 1.125rem;
}
